// extracted by mini-css-extract-plugin
module.exports = {"auth_page":"Auth_auth_page__YtMHV","sign_in_wrapper":"Auth_sign_in_wrapper__EyDEX","sign_up_wrapper":"Auth_sign_up_wrapper__qyS5Z","img":"Auth_img__T4E75"};